import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { DEPARTMENT_MAP } from "./option";
import s from "./Breadcrams.less";

export const PKDBreadcrams = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const newArrays = location.pathname.split("/");

  const goBack = () => {
    history.replace("/pkd/");
  };

  return (
    <ul className={s.breadcrams}>
      {newArrays.map((item, index) => {
        let labelKey = "";

        if (index === 0) {
          labelKey = "pkd.pkd";
        } else if (index === 1) {
          const categoryId = newArrays[index + 1];
          const categoryName = DEPARTMENT_MAP[categoryId] || "default";
          labelKey = `pkd.${categoryName}`;
        } else {
          labelKey = `pkd.${newArrays[index - 1]}`;
        }

        return (
          <li key={index}>
            <a href="#" onClick={goBack}>
              {t(labelKey)}
            </a>
          </li>
        );
      })}
    </ul>
  );
};
